module.exports = __webpack_public_path__ + "img/特产店铺1.c0de7edf.png";